import { Box, Divider, IconButton, InputLabel, Typography, styled } from '@mui/material';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'

import ColorBlindTest from './sub-form-sections/ColorBlindTest';
import CustomDialog from '../../../components/CustomDialog/CustomDialog';
import CustomToast from '../../../components/Toast/CustomToast';
import DRGrading from './sub-form-sections/DRGrading';
import { ENDPOINT } from '../../../services/endPoints';
import FacilitySection from './sub-form-sections/FacilitySection';
import FocusedHistory from './sub-form-sections/FocusedHistory';
import DiabeticFormPdf from '../../../components/Diabetic_Pdf/DiabeticFormPdf';
import IdentifyingSection from './sub-form-sections/IdentifyingSection';
import InputController from '../../../components/InputController/InputController';
import KnownPatients from './sub-form-sections/KnownPatients';
import PresentingComplaintSection from './sub-form-sections/PresentingComplaintSection'
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';
import SummaryDiabetic from './sub-form-sections/SummaryDiabetic';
import VisualAcuityTest from './sub-form-sections/VisualAcuityTest';
import { useForm } from 'react-hook-form';
import useMasterApi from '../../../services/useMasterApi';
import useToast from '../../../hooks/useToast';

export const ParentContainerSection = ({heading=false, children})=>{
  return (
    <>
      <Box sx={{ border: "1px solid", borderColor: "#DDDDDD", display: "flex", flexDirection: "column", gap: "1rem", borderRadius: "10px", mb: "0.5rem" }}>
        {heading && <Box sx={{ backgroundColor: "#F5F5F5", p: "0.5rem", borderRadius: "inherit" }}>
          <Typography variant="h6" sx={{ position: "relative", left: "10px", fontWeight: "bold" }}>{heading}</Typography>
        </Box>}
        <Box sx={{ width: "95%", margin: "0 auto",  }}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export const CustomInputLable = styled(InputLabel)(({theme})=>({
  fontSize: "14px",
  textWrap: "wrap",
  fontWeight: "bold",
  color: "black",
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },
}));

export const InputContainer = styled(Box)(({theme, width, fitcontent, minWidth})=>({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  width: "100%",
  gap: "1rem",
  "& > label:first-of-type": {
    // maxWidth: minWidth ? minWidth : undefined,
    width: width ? width : fitcontent ? fitcontent : "20%",
  },
  [theme.breakpoints.down("lg")]:{
    "& > label:first-of-type": {
      //  maxWidth: minWidth ? minWidth : undefined,
      width:width ? width : fitcontent ? fitcontent : "15%",
    },
  },
  [theme.breakpoints.down("md")]:{
    flexDirection: "column",
    gap: "0.35rem",
    "& > label:first-of-type": {
      width: "100%",
    },
    "& > div:first-of-type": {
      width: "100%",
    },
  },

  marginBottom: "1rem"

}));

const DiabeticForm = ({ formData,rejected }) => {
  const hospitalId = localStorage.getItem("hospitalId");
  const { put: statusUpdate, data} = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  
  useEffect(()=>{
    if(data.success){
      showToast("success", "Status Comment Added Successfully")
      rejected.setIsRejected(true);
    }else {
      rejected.setIsRejected(false);
    }
  },[data])

  const componentRef = useRef();

  const { handleSubmit, setValue, getValues, watch, control, formState: { errors } } = useForm({
    defaultValues: {
      facility_name: formData?.facility_name || "",
      facility_type: formData?.facility_type || "",
      facility_date: formData?.form_filling_Date || "",
      // nurse_name: formData?.nurse_name || "",

      patient_name: formData?.patient_name || "",
      patient_dob: formData?.patient_DOB || "",
      patient_gender: formData?.patient_gender || "",
      cmis_number: formData?.patient_cmis_id || "",

      presenting_complaint: formData?.presenting_complaint || "",

      redness: {
        left: formData?.presenting_complaint_left_redness || [],
        right: formData?.presenting_complaint_right_redness || []
      },

      visionLoss: {
        left: formData?.presenting_complaint_left_visionLoss || [],
        right: formData?.presenting_complaint_right_visionLoss || []
      },

      pain: {
        left: formData?.presenting_complaint_left_pain || [],
        right: formData?.presenting_complaint_right_pain || []
      },

      eyeInjury: {
        left: formData?.presenting_complaint_left_eyeInjury || [],
        right: formData?.presenting_complaint_right_eyeInjury || []
      },

      visualDisturbances: {
        left: formData?.presenting_complaint_left_visualDisturbances || [],
        right: formData?.presenting_complaint_right_visualDisturbances || []
      },

      otherComplaints: formData?.presenting_complaint_otherComplaints || "",

      reviewSystem: formData?.presenting_complaint_reviewSystem || [],

      focused_past_ocular_history: formData?.focused_past_ocular_history || "", // newly added check UI
      focused_past_ocular_history_comment: formData?.focused_past_ocular_history_comment || "", // newly added check UI

      pasthistory_comborbidity: formData?.pasthistory_comborbidity || [],
      on_treatment: formData?.on_treatment || "",
      treatment_type: formData?.treatment_type || [],

      treatment_years: formData?.treatment_years || "",
      date_of_diagnosis: formData?.date_of_diagnosis || "",
      type_of_diagnosis: formData?.type_of_diagnosis || "",
      current_medication: formData?.current_medication || "",
      medication_oral_injection: formData?.medication_oral_injection || [],
      blood_sugar_level: {
        RBS: formData?.blood_sugar_level?.RBS || "",
        FBS: formData?.blood_sugar_level?.FBS || "",
        HbA1c: formData?.blood_sugar_level?.HbA1c || ""
      },
      blood_sugar_levels: formData?.blood_sugar_levels || "",

      risk_factor_excercise: formData?.risk_factor_excercise || "",
      alochol_use: formData?.alochol_use || "",
      diet: formData?.diet || "",
      smoker: formData?.smoker || "",

      risk_rating: formData?.form_risk_rating || "",
      diabetic_comments: formData?.diabetic_comments || "",

      color_blindness_left: formData?.color_blindness_left || "",
      color_blindness_right: formData?.color_blindness_right || "",

      visual_acuity_left: formData?.visual_acuity_left || "",
      visual_acuity_right: formData?.visual_acuity_right || "",

      dr_retinopathy_left: formData?.dr_retinopathy_left || "",
      dr_retinopathy_right: formData?.dr_retinopathy_right || "",

      image1: formData?.image1 || "",
      image2: formData?.image2 || "",
      image3: formData?.image3 || "",
      image4: formData?.image4 || "",

      clinic_name: formData?.hospital_Name || "",
      referral_site_name: formData?.hospital_Name || "",

    }
  });

  const onSubmit = async (data) => {
    // console.log("dataValue", data)
  }

  const onReject = (formCode, comment) => {
    statusUpdate(`${ENDPOINT.STATUS}/${formCode}`, { form_accept_reject: "2", doctore_comments1: comment, form_type: formData?.form_type });
  }

  return (
    <>
      <div>
      <ReactToPrint
        trigger={() => <IconButton sx={{
            borderRadius: "2%", ":hover": {
              background: (theme) => theme.palette.secondary.main,
              borderRadius: "2%"
            }
          }}><strong>Print form</strong><PrintIcon />
          </IconButton>}
        content={() => componentRef.current}
      />
      <div style={{ display: "none" }}>
        <DiabeticFormPdf ref={componentRef} formData={formData}/>
      </div>
    </div>

      <form onSubmit={handleSubmit(onSubmit)}>
      {(formData?.form_accept_reject || rejected.isRejected) && <Typography variant='h1' color="error" sx={{fontWeight:"bold", textAlign: "center"}}>This form has been rejected by the referred hospital</Typography>}
        <Box sx={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-end" }}>
          {hospitalId === formData?.hospital_id ? <CustomDialog isStatus={formData?.form_accept_reject || rejected.isRejected}  formCode={formData?.form_code} onReject={onReject} /> : null}
        </Box>
        <Box id="divToPrint" sx={{ padding: "1rem" }} >
          <FacilitySection control={control} errors={errors} getValues={getValues} setValue={setValue} />

          {/* <FormLayoutGrid> */}
            <Box>
              <IdentifyingSection control={control} errors={errors} />
              <PresentingComplaintSection control={control} errors={errors} getValues={getValues} setValue={setValue} watch={watch}/>
              <FocusedHistory control={control} errors={errors} getValues={getValues} setValue={setValue} watch={watch}/>
              <KnownPatients control={control} errors={errors} getValues={getValues} watch={watch}/>
            </Box>

            <Box>
              <ColorBlindTest control={control} errors={errors} getValues={getValues} />
              <VisualAcuityTest control={control} errors={errors} getValues={getValues} />

              <DRGrading control={control} errors={errors} getValues={getValues} />
              <SummaryDiabetic control={control} errors={errors} getValues={getValues} />

            </Box>

          {/* </FormLayoutGrid> */}

          {/* <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "1rem", my: 1 }}> */}
            {/* <Box sx={{ flex: "1 1 50%" }}>
              <InputLabel sx={{ color: (theme) => theme.palette.black.main, fontWeight: "bold", my: 1 }}>Clinic Name</InputLabel>
              <InputController
                name="clinic_name"
                label="Clinic Name"
                control={control}
                errors={errors}
                getValues={getValues}
                size="small"
                isDisabled={true}
              />
            </Box> */}
            <Box sx={{ display: "flex", justifyContent: "space-between", width:"100%", gap:"2rem", my:2}}>
                      <Box sx={{ flex: "1 1 50%"}}>
                      <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold", my:2}}>Referred Tertiary Healthcare Facility Name</InputLabel>
                        <InputController
                            name="referral_site_name"
                            label="Referred Tertiary Healthcare Facility Name"
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            size="small"
                            isDisabled={true}
                         />
                      </Box> 
                 </Box>
          </Box>
        {/* </Box> */}
        {/* <Button type='submit' size='small'>Submit</Button> */}
      </form>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  )
}

export default DiabeticForm